export default function Overlay({ isActive, onClick }) {
return (
<div className={`overlay ${isActive ? "active" : ""}`} onClick={onClick} />
);
}